import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/app/node_modules/gatsby-theme-docz/src/base/Layout.js";
import ThemeProvider from './Theme/ThemeProvider';
import { Playground, Props } from 'docz';
import Button from './Button';
import FlatButton from './Button/FlatButton';
import OutlineButton from './Button/OutlineButton';
import UnstyledButton from './Button/UnstyledButton1.js';
import Select from './Input/Select/Select';
import Options from './Icons/Options';
import Flex from './Layout/Flex';
import AvatarWithName from './Img/AvatarWithName';
import ButtonMenuMultiLevel from './Menu/ButtonMenu/ButtonMenuMultiLevel';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "demo"
    }}>{`Demo`}</h1>
    <Playground __position={0} __code={'<ThemeProvider>\n  <div style={{ padding: \'16px\', height: \'800Px\' }}>\n    <Button text=\"foo\" />\n    <br />\n    <Button icon={<Options />} type=\"primary\" text=\"foo\" />\n    <br />\n    <OutlineButton icon={<Options />} type=\"primary\" text=\"foo\" />\n    <br />\n    <OutlineButton icon={<Options />} type=\"secondary\" text=\"foo\" />\n    <br />\n    <FlatButton icon={<Options />} type=\"error\" text=\"foo\" />\n    <FlatButton icon={<Options />} type=\"success\" text=\"foo\" />\n    <FlatButton icon={<Options />} type=\"warning\" text=\"foo\" />\n    <br />\n    <div style={{ padding: \'16px\' }}>\n      <Select\n        style={{ width: \'300px\' }}\n        onChange={(event, value) => console.log({ selectedValue: value })}\n      >\n        <Flex key=\"none\" value={null}>\n          None\n        </Flex>\n        <Flex value={\'Ava\'}>\n          <AvatarWithName\n            src={\'https://randomuser.me/api/portraits/women/82.jpg\'}\n            name={\'Ava\'}\n          />\n        </Flex>\n        <Flex value={\'Regina\'}>\n          <AvatarWithName\n            src={\'https://randomuser.me/api/portraits/women/37.jpg\'}\n            name={\'Regina\'}\n          />\n        </Flex>\n      </Select>\n    </div>\n  </div>\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      ThemeProvider,
      Playground,
      Props,
      Button,
      FlatButton,
      OutlineButton,
      UnstyledButton,
      Select,
      Options,
      Flex,
      AvatarWithName,
      ButtonMenuMultiLevel,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
    <div style={{
          padding: '16px',
          height: '800Px'
        }}>
      <Button text="foo" mdxType="Button" />
      <br />
      <Button icon={<Options mdxType="Options" />} type='primary' text="foo" mdxType="Button" />
      <br />
      <OutlineButton icon={<Options mdxType="Options" />} type='primary' text="foo" mdxType="OutlineButton" />
      <br />
      <OutlineButton icon={<Options mdxType="Options" />} type='secondary' text="foo" mdxType="OutlineButton" />
      <br />
      <FlatButton icon={<Options mdxType="Options" />} type='error' text="foo" mdxType="FlatButton" />
      <FlatButton icon={<Options mdxType="Options" />} type='success' text="foo" mdxType="FlatButton" />
      <FlatButton icon={<Options mdxType="Options" />} type='warning' text="foo" mdxType="FlatButton" />
      <br />
      <div style={{
            padding: '16px'
          }}>
        <Select style={{
              width: '300px'
            }} onChange={(event, value) => console.log({
              selectedValue: value
            })} mdxType="Select">
          <Flex key="none" value={null} mdxType="Flex">None</Flex>
          <Flex value={'Ava'} mdxType="Flex">
            <AvatarWithName src={'https://randomuser.me/api/portraits/women/82.jpg'} name={'Ava'} mdxType="AvatarWithName" />
          </Flex>
          <Flex value={'Regina'} mdxType="Flex">
            <AvatarWithName src={'https://randomuser.me/api/portraits/women/37.jpg'} name={'Regina'} mdxType="AvatarWithName" />
          </Flex>
        </Select>
      </div>
    </div>
  </ThemeProvider>
    </Playground>
    <Playground __position={1} __code={'<ThemeProvider>\n  <div style={{ padding: \'16px\' }}>\n    <ButtonMenuMultiLevel\n      style={{ alignItems: \'stretch\', display: \'flex\' }}\n      anchor={\'left\'}\n      buttonWrapperStyle={{\n        position: \'inherit\',\n        // fuck: \'eslint\',\n        height: \'100%\',\n        alignItems: \'stretch\',\n        display: \'flex\',\n      }}\n      BoxWrapperUIStyle={{\n        width: \'auto\',\n        zIndex: 1,\n      }}\n      menuDescriptor={[\n        {\n          label: \'foo\',\n          children: [{ label: \'bar\' }],\n        },\n      ]}\n      button={\n        <UnstyledButton\n          style={{\n            width: \'32px\',\n            height: \'100%\',\n            display: \'flex\',\n            alignItems: \'stretch\',\n          }}\n          icon={<Options />}\n        />\n      }\n    />\n  </div>\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      ThemeProvider,
      Playground,
      Props,
      Button,
      FlatButton,
      OutlineButton,
      UnstyledButton,
      Select,
      Options,
      Flex,
      AvatarWithName,
      ButtonMenuMultiLevel,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
     <div style={{
          padding: '16px'
        }}>
      <ButtonMenuMultiLevel style={{
            alignItems: 'stretch',
            display: 'flex'
          }} anchor={'left'} buttonWrapperStyle={{
            position: 'inherit',
            // fuck: 'eslint',
            height: '100%',
            alignItems: 'stretch',
            display: 'flex'
          }} BoxWrapperUIStyle={{
            width: 'auto',
            zIndex: 1
          }} menuDescriptor={[{
            label: 'foo',
            children: [{
              label: 'bar'
            }]
          }]} button={<UnstyledButton style={{
            width: '32px',
            height: '100%',
            display: 'flex',
            alignItems: 'stretch'
          }} icon={<Options mdxType="Options" />} mdxType="UnstyledButton" />} mdxType="ButtonMenuMultiLevel" />
      </div>
  </ThemeProvider>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      